import { DefaultRoutingProvider } from '@bugsnag/browser-performance';
import { matchPath } from 'react-router-dom';

function flattenRoutes(routes, _prefix = '') {
    const prefix = `${!_prefix || _prefix === '/' ? _prefix : `${_prefix}/`}`;
    return [
        ...routes.map(route => `${prefix}${route.path || ''}`),
        ...routes.reduce((accum, route) => [...accum, ...(route.children ? flattenRoutes(route.children, `${prefix}${route.path}`) : [])], [])
    ];
}
class ReactRouterRoutingProvider extends DefaultRoutingProvider {
    constructor(routes, basename) {
        const normalizedBasename = !basename || basename === '/' ? '' : basename;
        function resolveRoute(url) {
            return flattenRoutes(routes).find((fullRoutePath) => { var _a; return (_a = matchPath(fullRoutePath, url.pathname.replace(normalizedBasename !== null && normalizedBasename !== void 0 ? normalizedBasename : '', ''))) === null || _a === void 0 ? void 0 : _a.pattern.path; }) || 'no-route-found';
        }
        super(resolveRoute);
    }
}

export { ReactRouterRoutingProvider };
